<template>
  <article class="chat-message-list">
    <span class="chat-date">2023년 6월 4일</span>

    <ul class="chat-message-item">
      <li class="avatar">
        <img src="../assets/img-user-default.png" alt="" />
      </li>
      <li class="content">
        안녕하세요. 상품 팔렸나요? 구매하고싶어요. 완전 제가 찾던 상품 그
        자체거든요.
      </li>
      <li class="time">오전 10:20</li>
    </ul>

    <ul class="chat-message-item me">
      <li class="content">채팅기능은 준비중입니다.</li>
      <li class="time">오전 10:21</li>
    </ul>
  </article>
</template>
